import React from 'react';
import { Card, Typography, Row, Col, List, Divider } from 'antd';
import { PhoneOutlined, MailOutlined, HomeOutlined, GlobalOutlined } from '@ant-design/icons';
import './Contact.less';

const { Title, Paragraph } = Typography;

const Contact: React.FC = () => {
  const contactInfo = [
    {
      icon: <PhoneOutlined />,
      title: '联系电话',
      content: '010-12345678',
    },
    {
      icon: <MailOutlined />,
      title: '电子邮箱',
      content: 'info@bupt.edu.cn',
    },
    {
      icon: <HomeOutlined />,
      title: '通讯地址',
      content: '北京市海淀区西土城路10号',
    },
    {
      icon: <GlobalOutlined />,
      title: '学校官网',
      content: 'https://www.bupt.edu.cn',
    },
  ];

  const campusInfo = [
    {
      title: '海淀校区',
      address: '北京市海淀区西土城路10号',
      postalCode: '100876',
    },
    {
      title: '昌平校区',
      address: '北京市昌平区沙河高教园区',
      postalCode: '102206',
    },
  ];

  return (
    <div className="about-contact">
      <Title level={2}>联系我们</Title>
      <Row gutter={[24, 24]}>
        <Col xs={24} lg={16}>
          <Card>
            <Title level={4}>联系信息</Title>
            <Row gutter={[16, 16]}>
              {contactInfo.map((item, index) => (
                <Col key={index} xs={24} md={12}>
                  <Card type="inner" size="small" title={
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      {item.icon}
                      <span>{item.title}</span>
                    </div>
                  }>
                    <Paragraph>{item.content}</Paragraph>
                  </Card>
                </Col>
              ))}
            </Row>
            
            <Divider orientation="left">校区地址</Divider>
            <List
              itemLayout="horizontal"
              dataSource={campusInfo}
              renderItem={(item) => (
                <List.Item>
                  <List.Item.Meta
                    title={<strong>{item.title}</strong>}
                    description={
                      <div>
                        <p>地址：{item.address}</p>
                        <p>邮编：{item.postalCode}</p>
                      </div>
                    }
                  />
                </List.Item>
              )}
            />
          </Card>
        </Col>
        
        <Col xs={24} lg={8}>
          <Card>
            <Title level={4}>交通指南</Title>
            <Paragraph>
              <strong>海淀校区</strong>
            </Paragraph>
            <Paragraph>
              公交：乘坐304路、323路、375路、392路、438路、478路、484路、562路、604路、632路、693路、
              694路、695路、运通103路、运通109路、运通113路至羊小羊站下车。
            </Paragraph>
            <Paragraph>
              地铁：乘坐10号线至西土城站下车，B口出，步行约800米即可到达。
            </Paragraph>
            <Divider />
            <Paragraph>
              <strong>昌平校区</strong>
            </Paragraph>
            <Paragraph>
              公交：乘坐670路、670路快车、883路、889路至羊小羊站下车。
            </Paragraph>
            <Paragraph>
              地铁：乘坐昌平线至沙河站下车，换乘公交或出租车前往。
            </Paragraph>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Contact;